import React, { useRef } from 'react'
import { ClientType } from '../../../store/slices/clientsSlice'
import { ReactComponent as GoldenProfile } from '../../../assets/images/Profile Icon gold.svg'
import { ReactComponent as Download } from '../../../assets/images/Download.svg'

import QRCode from 'react-qr-code'
import { useSelector } from 'react-redux'
import { selectState } from '../../../store/slices/themeSlice'
import useCustomStyles from '../../../hooks/useCustomStyles'
import { clientInfoStyles } from '../../../assets/styles/ClientsStyles/clientInfoStyles'

type ClientInfoCardProps = { client: ClientType }

const ClientInfoCard: React.FC<ClientInfoCardProps> = ({ client }) => {
  const { theme } = useSelector(selectState)
  const classes = useCustomStyles(clientInfoStyles, theme)

  const qrWrapperRef = useRef<HTMLDivElement | null>(null)
  ////NOTE: I'M USING STATIC QR CODE BASSAM
  const downloadQRCode = () => {
    if (qrWrapperRef.current) {
      // Find the SVG element inside the wrapper
      const svg = qrWrapperRef.current.querySelector('svg')
      if (svg) {
        const svgData = new XMLSerializer().serializeToString(svg)
        const svgBlob = new Blob([svgData], {
          type: 'image/svg+xml;charset=utf-8',
        })
        const url = URL.createObjectURL(svgBlob)

        // Create a download link
        const link = document.createElement('a')
        link.href = url
        link.download = `QR_Code_${client.access_code_data[0].id}.svg`
        document.body.appendChild(link)
        link.click()

        // Cleanup
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }
    }
  }
  // Prevent rendering when status is not "pending"
  if (client.verificationStatus !== 'pending') return null

  // Define the rows and their values
  let rows: { label: string; value: string | undefined }[] = []
  if (client.type === 'invite code')
    rows = [
      { label: 'Name', value: client.user_name },
      { label: 'Email', value: client.email },
      { label: 'Type', value: client.type || '' },
      { label: 'Contract', value: 'Ellayon Contract' },
      { label: 'Validity', value: '12 Months' },
      { label: 'Status', value: client.verificationStatus || '' },
      { label: 'Access Code', value: 'XXXXXXXXXXXXXXXXXXX' },
    ]
  else {
    rows = [
      { label: 'Name', value: client.pending_user_name },
      { label: 'Email', value: client.pending_email },
    ]

    if (client.clientId) {
      rows.push({ label: 'Client ID', value: client.clientId })
    }
    rows.push({ label: 'Access Code', value: client.access_code_data[0].id })
    if (client.contract) {
      rows.push({ label: 'Contract', value: client.contract })
    }
    rows.push({
      label: 'Validity',
      value: client.access_code_data[0].expire_at || '',
    })

    if (
      client.role_type === 'advisor' &&
      client.roles &&
      client.roles.length > 0
    ) {
      rows.push({ label: 'Roles', value: client.roles.join(', ') })
    }
  }
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <p className={classes.headerText}>Personal Information</p>
      </div>

      <div className={classes.contentContainer}>
        <div className={classes.profileSection}>
          <GoldenProfile width={75} height={75} />
        </div>

        <div className={classes.infoGrid}>
          <table className={classes.table}>
            <tbody>
              {rows.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 1 ? '#fff' : ' #F6F6F6', // White for even, red for odd
                    // borderBottom: "1px solid #eee",
                    maxHeight: '10',
                  }}
                >
                  <td className={classes.labelCell}>{row.label}</td>
                  <td className={classes.valueCell}>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={classes.qrSection}>
            <div ref={qrWrapperRef}>
              <QRCode value={client.access_code_data[0].id} size={180} />
            </div>

            <div className={classes.actionButton} onClick={downloadQRCode}>
              <div className={classes.buttonIcon}>
                <Download width={20} height={20} />
              </div>
              <p className={classes.buttonText}>Download QR Code</p>
            </div>

            {/* <div className={classes.actionButton} onClick={downloadQRCode}>
              <div className={classes.buttonIcon}>
                <Trash width={20} height={20} />
              </div>
              <p className={classes.buttonText}>Remove Licence</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
export default ClientInfoCard
